export type ListResponse<T> = {
  data: {
    list: Array<T>;
    records: Array<T>;
    pagination: {
      page: number;
      pageSize: number;
      pages: number;
      total: number;
    };
  };
};

export type ListParams = {
  pageNo: number;
  pageSize: number;
  [key: string]: any;
};

export type StateListType<T> = {
  total: number;
  pagination: {
    current: number;
    pageSize: number;
  };
  filter: Record<string, string[]>;
  sorter: Record<string, string>;
  data: Array<T>;
  status: string;
  error: string;
};

export enum FIELD_TYPES {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  ARRAY = 'ARRAY',
  RADIO = 'RADIO',
  SECTION = 'SECTION',
  UPLOAD = 'UPLOAD',
  DATE = 'DATE',
  LABEL = 'LABEL',
  TITLE = 'TITLE',
  PARAGRAPH = 'PARAGRAPH',
  ROW = 'ROW', // Specified Type with item one row have many cols
  COL = 'COL',
  DEFECTS = 'DEFECTS', // Specified Type to render defects list
  CHECKLIST = 'CHECKLIST' // Specified Type to render check list
}

export type Product = {
  id: string | number;
  name: string;
  itemNo: string;
  supplier: any;
  image: any;
};
